<script>
import {mapActions, mapGetters} from "vuex";
import {useMobileMenu} from "@/mixins/useMobileMenu";
import MobileCommunePartnerDisplay from "@/components/navigation/private/MobileCommunePartnerDisplay.vue";

export default {
  name: "ServiceColumn",
  components: {MobileCommunePartnerDisplay},
  mixins: [useMobileMenu],
  computed: {
    ...mapGetters('navigation', ['getServices', 'getNavTitle']),
    columnStyle() {
      if(this.useMobileMenu) return {
        paddingTop: '16px'
      };
      return {
        paddingTop: '105px',
        width: '320px',
        height: '100vh',
      };
    }
  },
  methods: {
    ...mapActions('navigation', ['setSelectedServiceId', "setSelectedServiceAreaId"]),
    onServiceClick(service) {
      if(service.link) {
        this.setSelectedServiceAreaId(null);
        return;
      }
      this.setSelectedServiceId(service.id);
    },
    onTitleClick() {
      this.setSelectedServiceAreaId(null);
    }
  }
}
</script>

<template>
<div id="service-column" :style="columnStyle">
  <v-list>
  <v-list-item  v-if="useMobileMenu" style="cursor: pointer" class="menu-item" @click="onTitleClick">
    <v-list-item-content :class="{'nav-item-border' : useMobileMenu}">
      <div class="d-flex align-center nav-title">
        <v-icon left>mdi-chevron-left</v-icon>
        {{ getNavTitle }}
      </div>
    </v-list-item-content>
  </v-list-item>
  <v-list-item v-for="service of getServices" :key="service.id" :class="{'nav-item-border' : useMobileMenu}" style="cursor: pointer" class="menu-item" @click="onServiceClick(service)" :to="service.link">
    <v-list-item-content class="sub-menu-item">
      <div class="d-flex align-center sub-menu-font-size justify-space-between">
        {{ service.title }}
        <v-icon size="17" v-if="!service.link">mdi-chevron-right</v-icon>
      </div>
    </v-list-item-content>
  </v-list-item>
</v-list>
  <mobile-commune-partner-display v-if="useMobileMenu" />
</div>
</template>

<style scoped>
#service-column {
  background: #FFFFFF;
}

.item-text {
  font-size: 16px;
  font-family: "GeometriaMedium", sans-serif;
}

.menu-item:hover, .sub-menu-item:hover {
  background: #F5DBE6 !important;
  color: #B40055 !important;
  text-decoration: none !important;
}

</style>
